export default "__VITE_ASSET__dQUuoHUa__"